import React from 'react';
import OperatorRespPage from './../OperatorRespPage/OperatorRespPage';

const OperatorTypeRespPage = (props) => {
    return <OperatorRespPage
        {...props}
        busTypePage={true}
    />
}
export default OperatorTypeRespPage;
